<div class="row">
  <div class="col-md-12 mt-4">
    <div id="accordion" class="panel-group">
      <div class="panel">
        <div class="panel-heading">
          <h4 class="panel-title">
            <a href="#acceptance" class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion"
              aria-expanded="false"><i class="fa fa-check" aria-hidden="true"></i>{{'' | i18n: 'acceptance-criteria'}}
            </a>
          </h4>
        </div>
        <div id="acceptance" class="panel-collapse collapse">
          <div class="row">
            @if (!isNL()) {
              <div class="col-lg-6">
                {{question1}}
              </div>
            }
            @if (isNL()) {
              <div class="col-lg-6">
                {{'' | i18n: 'oil-change-question'}}
              </div>
            }
            <div class="col-lg-6">
              {{getBooleanString(this.warranty.contract.oilChangesTimely)}}
            </div>
          </div>
          @if (warranty.contract.contractCode != '12BSUP' && warranty.contract.contractCode != '12MSUP') {
            <div
              class="row mt-4">
              @if (!isNL()) {
                <div class="col-lg-6">
                  {{question2}}
                </div>
              }
              @if (isNL()) {
                <div>
                  {{'' | i18n: 'pass-360-question'}}
                </div>
              }
              <div class="col-lg-6">
                {{getBooleanString(this.warranty.contract.passed360)}}
              </div>
            </div>
          }
        </div>

      </div>
      <div class="panel">
        <div class="panel-heading">
          <h4 class="panel-title">
            <a href="#details" class="accordion-toggle collapsed" data-toggle="collapse"
              data-parent="#accordion"
              aria-expanded="false"><i class="fa fa-check" aria-hidden="true"></i>{{'' | i18n: 'vehicle-details'}}</a>
            </h4>
          </div>
          <div id="details" class="panel-collapse collapse">
            <div class="row mt-2">
              <div class="col-lg-3">
                {{'' | i18n: 'chassis'}}:
              </div>
              <div class="col-lg-3">
                {{warranty.vehicle.vin}}
              </div>
              <div class="col-lg-3">
                {{'' | i18n: 'model-desc'}}:
              </div>
              <div class="col-lg-3">
                {{warranty.vehicle.modelDescription}}
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-lg-3">
                {{'' | i18n: 'brand'}}:
              </div>
              <div class="col-lg-3">
                {{warranty.vehicle.brand}}
              </div>
              <div class="col-lg-3">
                {{'' | i18n: 'colour'}}:
              </div>
              <div class="col-lg-3">
                {{warranty.vehicle.colour}}
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-lg-3">
                {{'' | i18n: 'model'}}:
              </div>
              <div class="col-lg-3">
                {{warranty.vehicle.model}}
              </div>
              <div class="col-lg-3">
                {{'' | i18n: 'date-of-registration'}}:
              </div>
              <div class="col-lg-3">
                {{warranty.vehicle.dateOfRegistration}}
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-lg-3">
                {{'' | i18n: 'manufacturers-start-date'}}:
              </div>
              <div class="col-lg-3">
                {{warranty.manufacturersWarrantyStartDate}}
              </div>
            </div>
          </div>
        </div>
        <div class="panel">
          <div class="panel-heading">
            <h4 class="panel-title">
              <a href="#customer" class="accordion-toggle collapsed" data-toggle="collapse"
                data-parent="#accordion" aria-expanded="false"><i class="fa fa-check"
              aria-hidden="true"></i>{{'' | i18n: 'owner-details'}}
            </a>
          </h4>
        </div>
        <div id="customer" class="panel-collapse collapse">
          <div class="row mt-2">
            <div class="col-lg-12">
              <app-customer-details [dealerOptions]="dealers" [editable]="editable" [showSearch]="false"
                [dealer]="dealer"
              [customer]="warranty.owner"></app-customer-details>
            </div>

          </div>
          <div class="row mt-2">
            <div class="col-lg-12">
              @if (warranty.user) {
                <h3>{{'' | i18n: 'user-details'}}</h3>
              }
              @if (warranty.user) {
                <app-customer-details [dealerOptions]="dealers" [editable]="editable" [showSearch]="false"
                  [dealer]="dealer"
                [customer]="warranty.user"></app-customer-details>
              }
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-lg-12">
              @if (warranty.keeper) {
                <h3>{{'' | i18n: 'keeper-details'}}</h3>
              }
              @if (warranty.keeper) {
                <app-customer-details [dealerOptions]="dealers" [editable]="editable" [showSearch]="false"
                  [dealer]="dealer"
                [customer]="warranty.keeper"></app-customer-details>
              }
            </div>
          </div>
        </div>

      </div>
      <div class="panel">
        <div class="panel-heading">
          <h4 class="panel-title">
            <a href="#contact" class="accordion-toggle collapsed" data-toggle="collapse"
              data-parent="#accordion" aria-expanded="false"><i class="fa fa-check"
            aria-hidden="true"></i>{{'' | i18n: 'warranty-contract-information'}}
          </a>
        </h4>
      </div>
      <div id="contact" class="panel-collapse collapse">
        <div class="row mt-2">
          <div class="col-lg-2">
            {{'' | i18n: 'contract-requesting-dealer'}}:
          </div>
          <div class="col-lg-2" [hidden]="warranty.contract.contractType==='MINI NEXT YUC'">
            {{warranty.contract.requestingDealer}}
          </div>
          @if (warranty.contract.contractType==='MINI NEXT YUC') {
            <div class="col-lg-2">
              {{this.deliveringAgentNumber}}
            </div>
          }
          <div class="col-lg-2">
            {{'' | i18n: 'contract-start'}}:
          </div>
          <div class="col-lg-2">
            {{warranty.contract.contractStartDate}}
          </div>

          <div class="col-lg-2">
            {{'' | i18n: 'warranty-reference'}}:
          </div>
          <div class="col-lg-2">
            {{warranty.warrantyNumber}}
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-lg-2">
            {{'' | i18n: 'warranty-name'}}:
          </div>
          <div class="col-lg-2">
            {{warranty.contract.contractType}}
          </div>
          <div class="col-lg-2">
            {{'' | i18n: 'contract-end'}}:
          </div>
          <div class="col-lg-2">
            {{warranty.contract.contractEndDate}}
          </div>

          <div class="col-lg-2">
            {{'' | i18n: 'selling-dealer'}}:
          </div>
          <div class="col-lg-2" [hidden]="warranty.contract.contractType==='MINI NEXT YUC'">
            {{warranty.contract.deliveryLocation}}
          </div>
          @if (warranty.contract.contractType==='MINI NEXT YUC') {
            <div class="col-lg-2" >
              {{this.beluxDealer}}
            </div>
          }
        </div>
        <div class="row mt-2">
          <div class="col-lg-2">
            {{'' | i18n: 'contract-duration'}}:
          </div>
          <div class="col-lg-2">
            {{warranty.contract.contractDuration}}
          </div>
          <div class="col-lg-2">
            {{'' | i18n: 'created-by'}}:
          </div>
          <div class="col-lg-2">
            {{warranty.createdBy}}
          </div>
        </div>
        <div class="row mt-2">
          <!-- calculatedRate -->
          <div class="col-lg-2">
            {{'' | i18n: 'calculated-rate'}}:
          </div>
          <div class="col-lg-2">
            {{keepDecimalTrailingZero(warranty.contract.initialPremium)}}
          </div>
          <!-- promotionDiscount -->
          <div class="col-lg-2">
            {{'' | i18n: 'promotion-discount-on-warranty-rate'}}:
          </div>
          <div class="col-lg-2">
            {{keepDecimalTrailingZero(warranty.contract.promotionDiscount)}}
          </div>
          <!-- penaltyOrDiscount -->
          <div class="col-lg-2">
            {{'' | i18n: 'penalty-discount-on-warranty-rate'}}:
          </div>
          <div class="col-lg-2">
            {{keepDecimalTrailingZero(warranty.contract.penaltyOrDiscount)}}
          </div>
          <!-- amountToBeCharged -->
          <div class="col-lg-2">
            {{'' | i18n: 'amount-to-be-charged'}}:
          </div>
          @if (amount(warranty.contract.amountToBeCharged)) {
            <div class="col-lg-2">
              {{keepDecimalTrailingZero(warranty.contract.amountToBeCharged)}}
            </div>
          }
          @if (!amount(warranty.contract.amountToBeCharged)) {
            <div class="col-lg-2">
              {{keepDecimalTrailingZero(warranty.contract.contractRate)}}
            </div>
          }
        </div>
      </div>
    </div>

    @if (hasCreditNote) {
      <div class="panel">
        <div class="panel-heading">
          <h4 class="panel-title">
            <a href="#credit-note" class="accordion-toggle collapsed" data-toggle="collapse"
              data-parent="#accordion" aria-expanded="false"><i class="fa fa-check"
            aria-hidden="true"></i>{{'' | i18n: 'credit-note'}}
          </a>
        </h4>
      </div>
      <div id="credit-note" class="panel-collapse collapse">
        <div class="row mt-2">
          <div class="col-lg-2">
            {{'' | i18n: 'date-actioned'}}:
          </div>
          <div class="col-lg-2">
            {{warranty?.sentToNwsDate | date: 'yyyy-MM-dd'}}
          </div>
          <div class="col-lg-2">
            {{'' | i18n: 'billed-date'}}:
          </div>
          <div class="col-lg-2">
            {{firstDayOfNextMonthDate(warranty?.dateCreated) | date:'yyyy-MM-dd'}}
          </div>
          <div class="col-lg-2">
            {{'' | i18n: 'cancellation-date'}}:
          </div>
          <div class="col-lg-2">
            {{creditNote?.refundDate | date:'yyyy-MM-dd'}}
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-lg-2">
            {{'' | i18n: 'refund-amount'}}:
          </div>
          <div class="col-lg-2">
            EUR {{creditNote?.refundAmount}}
          </div>
          <div class="col-lg-2">
            {{'' | i18n: 'credit-note-date'}}:
          </div>
          <div class="col-lg-2">
            {{firstDayOfNextMonthDate(creditNote?.refundDate) | date:'yyyy-MM-dd'}}
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-lg-2">
            {{'' | i18n: 'refund-comments-title'}}:
          </div>
          <div class="col-lg-4">
            {{creditNote?.comments}}
          </div>
        </div>
      </div>
    </div>
  }
</div>
</div>
</div>
